export const ORDER_PAYMENT_EXPORT_ID = 'order-payment';

export const ORDER_PAYMENT_TITLE = 'Cobranza';

export const LOCALIZED_PROPERTIES = {
  route: 'Ruta',
  user: 'Usuario',
  shipToName: 'Socio de Negocio',
  serial: 'Documento',
  paymentType: 'Tipo/Método Pago',
  date: 'Fecha',
  bankOperationNumber: 'Nro. Letra',
  bank: 'Banco',
  operationNumber: 'Operación',
  paying: 'Abono',
  amount: 'Pago Total',
};
